import React,{useEffect,  useState}from 'react'
import { Flex,  message,  Space, Table,Modal } from 'antd';
import ModalDel from '../../cpn/ModalDel';
import { UnorderedListOutlined } from '@ant-design/icons';
import SubmoduleEdit from './SubmoduleEdit';
import { useBnsBanBenDelMutation, useBnsBanBenListQuery } from '../../store/BnsKeJiApi';
import SubmoduleCheck from './SubmoduleCheck';
import SubmoduleAdd from './SubmoduleAdd';
function SubmoduleList(props) {       
    const [open, setOpen] = useState(false);
    const [list, setList] = useState(); 
    const {data, isSuccess} = useBnsBanBenListQuery({
        bbb_e_id:localStorage.getItem('e_id'),
        bbb_bg_id:props.bg_id,
        bbb_bgn_id:props.bgn_id,
    },{refetchOnMountOrArgChange:1});    
    useEffect(() => {
        if (isSuccess) {
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bbb_id:key,bbb_name,bbb_ctime,bbb_bg_id,bbb_bgn_id,bbb_bg_name,bbb_cname,bbb_jihua,bbb_xuzhi,bg_id,bg_name,bbb_bgn_name,bbb_dept_name,bbb_dept_id} = item;
                    return item = {key,bbb_name,bbb_ctime,bbb_bg_id,bbb_bgn_id,bbb_bg_name,bbb_cname,bbb_jihua,bbb_xuzhi,bg_id,bg_name,bbb_bgn_name,bbb_dept_name,bbb_dept_id}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.bbb_ctime;
                    let bTimeString = b.bbb_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   
    const columns = [
        {
            key: 'bbb_name',
            title: '子模块',
            dataIndex: 'bbb_name', 
            render: (text, record) => {
                return <SubmoduleCheck bbb_id={record.key} bbb_name={record.bbb_name}/>
            }           
        },
        {
            key: 'bbb_xuzhi',
            title: '子模块说明',            
            dataIndex: 'bbb_xuzhi',           
        },   
        {
            key: 'num',
            title: '编号',            
            dataIndex: 'key',           
        },      
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>{record.bbb_ctime + record.bbb_cname}</>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>  
                        <SubmoduleEdit 
                            bbb_id={record.key}                            
                        />   
                        <ModalDel onOk={() => {
                            del({bbb_id:record.key}).then((res) => {
                                console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('删除成功！')                                                                              
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('删除失败！'+res.data.Message)
                                }
                            })
                        }} />                         
                    </Space>
                </>
            }
        },
    ]   
    //删除
    const [del] = useBnsBanBenDelMutation()    
    return (
        <> 
            <a onClick={() => { setOpen(true) }}><UnorderedListOutlined /> 子模块列表</a>
            <Modal
                open={open}
                width={800}
                title={props.bg_name + ' - ' + props.bgn_name + "- 子模块列表"}
                onCancel={() => { setOpen(false); }}
            >
                <Flex style={{ marginBottom: 16 }} justify='flex-end'>                
                    <SubmoduleAdd bg_id={props.bg_id} bg_name={props.bg_name}  bgn_id={props.bgn_id} bgn_name={props.bgn_name}/> 
                </Flex>          
                <Table
                    columns={columns} 
                    dataSource={list} 
                    pagination={{showSizeChanger:true,defaultPageSize:'50',showTotal:(total) => `共${total}条`}}                 
                />
            </Modal>
        </>
    )
}

export default SubmoduleList